{
 "tag": {
  "x": 289,
  "y": 491,
  "w": 363,
  "h": 23,
  "lane": {
   "x": 270,
   "y": 478,
   "w": 400,
   "h": 62
  }
 },
 "brand": {
  "x": 306,
  "y": 552,
  "w": 329,
  "h": 40,
  "lane": {
   "x": 200,
   "y": 538,
   "w": 540,
   "h": 72
  }
 },
 "line1": {
  "x": 231,
  "y": 983,
  "w": 481,
  "h": 43,
  "lane": {
   "x": 180,
   "y": 974,
   "w": 580,
   "h": 52
  }
 },
 "line2": {
  "x": 344,
  "y": 1015,
  "w": 316,
  "h": 42,
  "lane": {
   "x": 180,
   "y": 1015,
   "w": 580,
   "h": 53
  }
 },
 "benefit": {
  "x": 166,
  "y": 1077,
  "w": 609,
  "h": 31,
  "lane": {
   "x": 140,
   "y": 1068,
   "w": 660,
   "h": 52
  }
 },
 "cta": {
  "x": 363,
  "y": 1160,
  "w": 217,
  "h": 29,
  "lane": {
   "x": 270,
   "y": 1150,
   "w": 400,
   "h": 62
  }
 }
}